import { render, staticRenderFns } from "./UpdateWarehouse.vue?vue&type=template&id=b35e9634&"
import script from "./UpdateWarehouse.vue?vue&type=script&lang=ts&"
export * from "./UpdateWarehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports